import { ModelProviderSchema, type ModelProvider } from '@reflex/shared';

/**
 * Map an agent-provider id (and, as a fallback, the model string) onto the
 * canonical {@link ModelProvider} enum the key picker filters by. Most
 * agent provider ids already match the enum; the model heuristic covers
 * matrix-driven catalogs whose provider id is absent or non-canonical.
 * Defaults to `anthropic` (the claude-code default).
 */
export function toModelProvider(providerId: string | null, model: string): ModelProvider {
  const direct = ModelProviderSchema.safeParse(providerId);
  if (direct.success) return direct.data;
  const m = model.toLowerCase();
  if (
    m.startsWith('claude') ||
    m === 'opus' ||
    m === 'sonnet' ||
    m === 'haiku' ||
    m.startsWith('anthropic')
  ) {
    return 'anthropic';
  }
  if (
    m.startsWith('gpt') ||
    m.startsWith('o1') ||
    m.startsWith('o3') ||
    m.startsWith('codex') ||
    m.startsWith('openai')
  ) {
    return 'openai';
  }
  if (m.startsWith('grok') || m.startsWith('xai')) return 'xai';
  if (m.startsWith('gemini') || m.startsWith('google')) return 'google';
  if (m.startsWith('openrouter/')) return 'openrouter';
  if (m.startsWith('fireworks-ai/')) return 'fireworks-ai';
  if (m.startsWith('baseten/')) return 'baseten';
  if (m.startsWith('vercel/')) return 'vercel';
  if (m === 'cursor' || m.startsWith('cursor-')) return 'cursor';
  if (m === 'composer' || m.startsWith('composer-')) return 'cursor';
  return 'anthropic';
}
